// extracted by mini-css-extract-plugin
export default {"root":"Chart_root__DqA9U","header":"Chart_header__ON6CA","title":"Chart_title__EvU2C","value":"Chart_value__K-glq"};